import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annvnx70wf35">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcrvxdkv7c1">The {totalBonuses} <span className="text-accent" data-id="element-21" data-mp="15q5ke05j9nrz">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-primary/60 bg-background shadow-lg shadow-foreground/10" data-id="element-22" data-mp="1jgisc2ifd2hb">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/15 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzoiygswexv3" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-highlight/50 bg-surface text-highlight" data-id="element-24" data-mp="2jieiw0lc5qyy">
                  <Icon className="glow-led h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="1qth0zyl1dw6q" />
                </span>
                <div data-id="element-26" data-mp="1vs20fvsgsbu4">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-27" data-mp="1vrikgkmdjxiq">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-foreground" data-id="element-28" data-mp="20qloc1qmbxp4">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="25rsw40srgwvs">{bonus.description}</p>
                  <p className="mt-2 text-sm font-bold" data-id="element-30" data-mp="3c6abou7sayqg">
                    <span className="sr-only" data-id="element-31" data-mp="3h4vdgy2opqh0">Value: </span>
                    <span className="text-muted line-through decoration-accent decoration-2" data-id="element-32" data-mp="3h7hkmwlny3yp">{bonusValue}</span>
                    <span className="ml-2 uppercase tracking-wide text-accent" data-id="element-33" data-mp="1c4arat1zf1co">Free</span>
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-accent bg-background px-6 py-6 text-center shadow-lg shadow-foreground/10 sm:flex-row sm:text-left" data-id="element-34" data-mp="1q1zck1zyoai9">
          <div data-id="element-35" data-mp="yajhdjkc9fgf">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-36" data-mp="te2u0rkyr54e">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-accent decoration-2" data-id="element-37" data-mp="175hc8w71r2ae">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-38" data-mp="eoesbp8ve4g5">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-39" data-mp="endi1mzohlzh">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-accent" data-id="element-40" data-mp="amth08bzhy82">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-41" data-mp="hbh4kzigkae" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}